import { getVeranstaltungen } from '../helpers/getVeranstaltungen';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as React from 'react';
import { TriggerService } from '../core/trigger/trigger_service';

interface VeranstaltungsAuswahlProps extends React.ClassAttributes<any> {
    data: any;
    veranstaltung: any;
    onVeranstaltungSelect: (veranstaltung: any) => void;
}

interface VeranstaltungsAuswahlState extends React.ClassAttributes<any> {
    veranstaltungen: any[];
}

export class VeranstaltungsAuswahl extends React.Component<VeranstaltungsAuswahlProps, VeranstaltungsAuswahlState> {

    constructor(props: any) {
        super(props);
        this.state = {
            veranstaltungen: [],
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    public static tid: number;

    componentDidMount(): void {
        const veranstaltungTid: number = VeranstaltungsAuswahl.tid;
        const veranstaltungen: any[] = getVeranstaltungen(this.props.data) || [];
        const veranstaltung: any = veranstaltungen.find((item: any) => item.tid === (veranstaltungTid || veranstaltungen[0].tid))
            || veranstaltungen.find((item: any) => item.tid === (veranstaltungen[0].tid));
        this.setState({ veranstaltungen }, () => {
            if (veranstaltungen.length && !this.props.veranstaltung) {
                this.props.onVeranstaltungSelect(veranstaltung);
            }
        });
    }

    render(): JSX.Element {
        const { veranstaltungen } = this.state;

        return (
            <div style={{ backgroundColor: 'var(--color-wform-background)', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <div style={{ flex: 1, maxWidth: 500, padding: 3 }}>
                    <select
                        value={this.props.veranstaltung ? this.props.veranstaltung.tid : -1}
                        onChange={(event: any) => {
                            const found: any = veranstaltungen.find((veranstaltung: any) => veranstaltung.tid === +event.target.value);
                            // console.log('Veranstaltung gewählt:', found ? found.name : '-');
                            VeranstaltungsAuswahl.tid = (found || {}).tid;
                            this.triggerService.fire('reload', IDs.ENT_STANDORT);
                            this.props.onVeranstaltungSelect(found);
                        }}
                        style={{ width: 500/*, backgroundColor: '#efefef', borderRadius: 5, border: '4px solid #fff', padding: 2, fontSize: 20*/ }}
                    >
                        {veranstaltungen.map((veranstaltung: any, index: number) =>
                            <option key={`veranstaltung-${index}`} value={veranstaltung.tid}>
                                {veranstaltung.name}
                            </option>
                        )}
                    </select>
                </div>
            </div>
        );
    }
}
